import React from "react";
import styled from "styled-components";

const GridColumn = styled.div`
  border-left: solid 1px #ddd;

  &:first-child {
    border-left: none;
  }
`;
const GridColumnHeader = styled.div`
  input {
    border: none;
    width: 100%;
    padding: 0.5rem;
    box-sizing: border-box;
    text-align: center;
    width: 3rem;
    margin: 0.3rem 0.3rem;
    font-weight: bold;
    color: #333;
    font-size: 1.5rem;
  }

  border-bottom: solid 1px #ddd;
`;
const GridColumnMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
`;

interface BubbleProps {
  selected?: boolean;
}
const StyledBubble = styled.div<BubbleProps>`
  font-weight: 500;
  color: #777;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    border 0.2s,
    background-color 0.2s;

  ${(props) => () => {
    if (props.selected) {
      return `
        border: solid 1px #44448f;
        background-color: #44448f;
        color: #fff;
      `;
    } else {
      return `
        border: solid 1px #ddd;
      `;
    }
  }}

  &:hover {
    border-color: #333;
  }
`;

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const ItemBubbleColumn: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <GridColumn>
      <GridColumnHeader>
        <input
          type="text"
          maxLength={1}
          value={props.value?.trim()}
          onChange={(e) =>
            props.onChange(e.target.value.length ? e.target.value : " ")
          }
        />
      </GridColumnHeader>
      <GridColumnMain>
        {[".", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].map((num) => {
          return (
            <StyledBubble
              key={num}
              selected={num === props.value}
              onClick={() => props.onChange(num)}
            >
              {num}
            </StyledBubble>
          );
        })}
      </GridColumnMain>
    </GridColumn>
  );
};

export default ItemBubbleColumn;
